module.exports = __webpack_public_path__ + "img/french_guiana.b257b59.webp";